import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'tasks_list_page' */ './TasksListPage'),
);
